import { render, staticRenderFns } from "./fndisclamier.vue?vue&type=template&id=2977d7a9&"
import script from "./fndisclamier.vue?vue&type=script&lang=js&"
export * from "./fndisclamier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports